document.addEventListener("DOMContentLoaded", function() {
    let select = document.querySelector('#locking-type');
      if (select.options.length > 1) {
        document.querySelector('.custom-select').classList.add('custom-select-wrapper');
      }
  });





// js for hide show reddem sections based on tag

 document.addEventListener("DOMContentLoaded", function () {
  console.log("aaa: script loaded");

  const redeemTabSelector = ".get-rewards-tab";
  const rewardSelector = ".referral-reward-container";
  const pointsSelector = ".current-customer-points";

  // --- Get customer tags dynamically from body ---
  function getCustomerTags() {
    const bodyEl = document.querySelector("body");
    const tagsString = bodyEl?.getAttribute("data-customer-tags") || "";
    const tags = tagsString
      .split(",")
      .map((t) => t.trim().toLowerCase())
      .filter(Boolean);
    console.log("aaa: detected cashback tags =", tags);
    return tags;
  }

  // --- Get current points ---
  function getCustomerPoints() {
    const el = document.querySelector(pointsSelector);
    if (!el) return 0;
    const pts = parseInt(el.textContent.replace(/\D+/g, "")) || 0;
    console.log("aaa: current points =", pts);
    return pts;
  }

  // --- Apply visibility dynamically based on tags ---
  function applyCashbackVisibility() {
    console.log("aaa: applying cashback visibility");

    const containers = document.querySelectorAll(rewardSelector);
    if (!containers.length) {
      console.log("aaa: reward section not found");
      return;
    }

    const tags = getCustomerTags();
    const points = getCustomerPoints();
    const tagMap = {
      cashback_05: 2,
      cashback_10: 3,
      cashback_25: 4,
      cashback_55: 5,
      cashback_100: 6,
      cashback_150: 7,
      cashback_200: 8,
      cashback_250: 9,
      cashback_500: 10,
    };

    // Hide all rewards first
    containers.forEach((c) => (c.style.display = "none"));

    if (!tags.length) {
      console.log("aaa: no cashback tags found — showing only last reward");
      const last = containers[containers.length - 1];
      if (last) last.style.display = "block";
      return;
    }

    // collect indexes to show
    const arr = Array.from(containers);
    const indexesToShow = new Set();
    indexesToShow.add(arr.length - 1); // always show last reward

    tags.forEach((tag) => {
      if (tagMap[tag]) {
        const index = arr.length - tagMap[tag];
        if (index >= 0) indexesToShow.add(index);
      }
    });

    // show selected rewards
    Array.from(indexesToShow).forEach((i) => {
      if (arr[i]) arr[i].style.display = "block";
    });

    console.log(
      "aaa: showing indexes from last =",
      Array.from(indexesToShow).map((i) => arr.length - i)
    );
    console.log("aaa: applied based on tags =", tags);
  }

  // --- Wait for reward section to appear ---
  function waitForRewards() {
    const observer = new MutationObserver(() => {
      const rewards = document.querySelectorAll(rewardSelector);
      if (rewards.length) {
        console.log("aaa: reward section detected, applying visibility");
        applyCashbackVisibility();
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // --- Redeem tab click ---
  document.addEventListener("click", function (e) {
    const tab = e.target.closest(redeemTabSelector);
    if (tab) {
      console.log("aaa: Redeem tab clicked");
      setTimeout(() => {
        waitForRewards();
      }, 400);
    }
  });

  console.log("aaa: script initialized");
});

